/* eslint-disable no-debugger */
import { hasValue, isNullOrUndefined } from './general-utils';
import { AxiosError, AxiosResponse } from 'axios';

export interface ResponseModel {
  hasErrors?: boolean;
  statusCode?: string;
  errorMessages?: string[];
  data?: any;
}

export const handleAxiosResponse = (response: AxiosResponse): ResponseModel => {


  const { data } = response;

  if (hasValue(data) && hasValue(data.errors)) {
    return {
      hasErrors: true,
      statusCode: response.status.toString(),
      errorMessages: Object.values(data.errors),
      data,
    } as ResponseModel;
  }

  return { hasErrors: false, data } as ResponseModel;
};

export function handleError(error: AxiosError) {
  console.error('API call failed. ' + error.message);

  const { config, response } = error;

  console.log('--- AXIOS ERROR RESPONSE ---');
  console.log('Status:', response?.status);
  console.log('Headers:', response?.headers);
  console.log('Data:', response?.data);

  const errorsInfo = getErrorsInfo(response);

  console.error('Error details:', {
    method: config?.method,
    url: config?.url,
    status: response?.status,
  });

  console.log('Errors Info: ', errorsInfo);
  return {
    hasErrors: true,
    statusCode: response?.status.toString() || '500',
    errorMessages: errorsInfo,
    data: response?.data,
  } as ResponseModel;
}

export const buildFormData = (data: object): FormData => {
  const formData = new FormData();

  Object.keys(data).forEach(key => {
    if (!isNullOrUndefined(data[key as keyof typeof data])) {
      formData.append(key, data[key as keyof typeof data]);
    }
  });

  return formData;
};

export const filterSensitiveData = (data: any[]): string[] => {
  // change-password-handler.ts, reset-password-handler.ts
  const SENSITIVE_KEYSWORDS = [
    'password',
    'pass',
    'confirmPassword',
    'newPassword',
    'oldPassword',
    'password_confirmation',
    'token',
    'accessToken',
  ];

  if (!Array.isArray(data)) {
    return [];
  }

  return data
    .map(String)
    .filter(
      message =>
        !SENSITIVE_KEYSWORDS.some(keyword =>
          message.toLowerCase().startsWith(keyword),
        ),
    );
};

export const getErrorsInfo = (
  response: AxiosResponse | undefined,
): string[] => {
  const data = response?.data;

  if (isNullOrUndefined(response?.data)) {
    return ['Something went wrong.'];
  }

  if (data.errors) {
    const { errors } = data;

    if (Array.isArray(errors)) {
      return filterSensitiveData(errors);
    }

    if (typeof errors === 'object' && errors !== null) {
      const allMessages = Object.values(errors).flat();
      return filterSensitiveData(allMessages);
    }
  }

  // Return data if the data.errors is not present
  const errors = Array.isArray(data) ? data : [data];
  return filterSensitiveData(errors);
};

export const getSSOUrl = (path?: string): string => {
  const ssoApiDomain =
    process.env['NEXT_PUBLIC_SSO_API_DOMAIN'] ||
    process.env['SSO_API_DOMAIN'] ||
    '';

  if (!path) {
    if (!hasValue(ssoApiDomain))
      console.error('NEXT_PUBLIC_SSO_API_DOMAIN is not defined');

    return ssoApiDomain;
  }

  return `${ssoApiDomain}${path}`;
};

export const getSSODomain = () => {
  return (
    process.env['NEXT_PUBLIC_SSO_API_DOMAIN'] ||
    process.env['SSO_API_DOMAIN'] ||
    'my.oneclub.golf'
  );
};
